import React from 'react';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import AddIcon from '@mui/icons-material/Add';
import { format, isToday } from 'date-fns';
import { USERS } from '../ChoresTouch/choreConstants';

const MealDayCard = ({ date, meal, chef, onClick, onMicClick }) => {
    const isCurrentDay = isToday(new Date(date));

    // Helper to get chef color/icon
    // Helper to get chef avatar
    const getChefAvatar = (chefName) => {
        const user = USERS.find(u => u.name.toLowerCase() === chefName?.toLowerCase());
        return user ? user.avatar : null;
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, scrollSnapAlign: 'center' }}>
            {/* External Header - Day Name (Left) & Date (Right) */}
            {/* External Header - Day Name Only */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                width: 280, 
                px: 1,
                pb: 1
            }}>
                <Typography variant="h4" fontWeight="900" color="white" sx={{ textShadow: '0 1px 2px rgba(255,255,255,0.2)', textTransform: 'uppercase', textAlign: 'center' }}>
                    {format(new Date(date), 'EEEE')}
                </Typography>
            </Box>

            <Paper
                elevation={isCurrentDay ? 8 : 2}
                onClick={onClick}
                sx={{
                    minWidth: 280,
                    width: 280,
                    height: 340,
                    borderRadius: 4,
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    // Gray background
                    bgcolor: '#276749', // Darker Green
                    backdropFilter: 'blur(10px)',
                    cursor: 'pointer',
                    border: isCurrentDay ? '4px solid #ffffff' : '2px solid transparent',
                    transition: 'transform 0.2s',
                    userSelect: 'none',
                    '&:hover': {
                        transform: 'translateY(-4px)'
                    }
                }}
            >
                {/* Meal Content */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 2, width: '100%' }}>
                    {meal ? (
                        <Typography variant="h5" fontWeight="700" color="white" sx={{ overflowWrap: 'break-word', width: '100%', textAlign: 'center', lineHeight: 1.3 }}>
                            {meal}
                        </Typography>
                    ) : (
                        // Large Black Plus Sign, No Background, Thick & Rounded
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            opacity: 0.8
                        }}>
                            <svg width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path 
                                    d="M12 4V20M4 12H20" 
                                    stroke="white" 
                                    strokeWidth="3.5" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Box>
                    )}
                </Box>

                {/* Footer */}
                <Box sx={{ mt: 'auto', pt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', minHeight: 40 }}>
                    <Box>
                        {chef ? (
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1,
                            }}>
                                <Box 
                                    component="img"
                                    src={`${getChefAvatar(chef)}`}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                    sx={{ 
                                        width: 40, 
                                        height: 40, 
                                        borderRadius: '50%', 
                                        border: '2px solid white',
                                        objectFit: 'cover'
                                    }} 
                                />
                                <Typography variant="h6" fontWeight="700" color="white" sx={{ textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}>
                                    {chef}
                                </Typography>
                            </Box>
                        ) : (
                           // Empty state: Leave blank as requested
                           null
                        )}
                    </Box>

                    {/* Mic Icon Removed */}
                </Box>
            </Paper>
        </Box>
    );
};

export default MealDayCard;
